import { render, staticRenderFns } from "./modalTipodedocumentos.vue?vue&type=template&id=95245bb2&scoped=true&"
import script from "./modalTipodedocumentos.vue?vue&type=script&lang=js&"
export * from "./modalTipodedocumentos.vue?vue&type=script&lang=js&"
import style0 from "./modalTipodedocumentos.vue?vue&type=style&index=0&id=95245bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95245bb2",
  null
  
)

export default component.exports